import { Button } from '@insify/design-system/components';
import { headingColor, headingSm, textMd } from '@insify/design-system/typography';
import clsx from 'clsx';

import { contact, contactButton, contactDescription, contactIcon, contactTitle } from './ContactOptions.module.css';

type ContactLink = {
  icon: React.ReactElement;
  label: string;
  link: string;
  trackingId: string;
};

export type ContactOptionsProps = {
  // TODO remove title and description from this component
  contactOptionsTitle?: string;
  contactOptionsDescription?: string;
  contactOptions: ContactLink[];
  className?: string;
};

export const ContactOptions: React.FC<ContactOptionsProps> = ({
  className,
  contactOptionsTitle,
  contactOptionsDescription,
  contactOptions,
}) => {
  if (contactOptions.length === 0) {
    return null;
  }

  return (
    <div className={clsx(contact, className)}>
      {contactOptionsTitle && <h3 className={clsx(headingSm, headingColor, contactTitle)}>{contactOptionsTitle}</h3>}
      {contactOptionsDescription && <p className={clsx(textMd, contactDescription)}>{contactOptionsDescription}</p>}
      {contactOptions?.map((contactOption) => {
        const { icon: Icon, label, trackingId } = contactOption;

        return (
          <Button
            trackingId={trackingId}
            className={contactButton}
            key={label}
            type='button'
            kind='neutral'
            rel='noreferrer'
            href={(contactOption as ContactLink).link}
            target='_blank'
            leftIcon={<Icon.type {...Icon.props} className={contactIcon} />}
          >
            {contactOption.label}
          </Button>
        );
      })}
    </div>
  );
};
